class ImageSwitcherAccordion {
    constructor() {
        this.accordions = document.querySelectorAll('.image-switcher-accordion');
    }

    init() {
        if (this.accordions.length > 0) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.accordions.forEach((accordion) => {
            const items = accordion.querySelectorAll('.collapsible[data-image]');

            // Bild per data-image-id finden statt über .closest('.columns')
            const imageId = accordion.dataset.imageId;
            const img = imageId ? document.getElementById(imageId) : null;

            if (!img) return;

            // Erstes Bild direkt setzen
            const firstItem = items[0];
            if (firstItem && firstItem.dataset.image) {
                img.src = firstItem.dataset.image;
            }

            items.forEach((item) => {
                const panel = item.querySelector('.is-collapsible');
                if (!panel) return;

                const observer = new MutationObserver(() => {
                    const isOpen = panel.getAttribute('aria-expanded') === 'true';
                    if (isOpen) {
                        this.switchImage(img, item.dataset.image);
                    }
                });

                observer.observe(panel, {
                    attributes: true,
                    attributeFilter: ['aria-expanded'],
                });
            });
        });
    }

    switchImage(img, newSrc) {
        if (!newSrc || img.src.endsWith(newSrc)) return;

        const picture = img.closest('picture');
        const target = picture || img;

        target.style.opacity = '0';
        setTimeout(() => {
            if (picture) {
                // Alle source-Tags aktualisieren
                const sources = picture.querySelectorAll('source');
                sources.forEach((source) => {
                    // srcset durch neue URL ersetzen (1x only, da wir keine 2x-URL haben)
                    source.removeAttribute('srcset');
                });
            }
            img.src = newSrc;
            img.removeAttribute('srcset');
            target.style.opacity = '1';
        }, 200);
    }
}

export default new ImageSwitcherAccordion();